import React, { useRef, useState } from "react";
import { Trans, t } from "@lingui/macro";
import { useWindowWidth } from "@react-hook/window-size";
import dynamic from "next/dynamic";
import useOnScreen from "hooks/useOnScreen";

const UspDesktopCarousel = dynamic(
  () => import("./usp-section").then((mod) => mod.UspDesktopCarousel),
  {
    ssr: false,
  }
);
const UspMobileCarousel = dynamic(
  () => import("./usp-section").then((mod) => mod.UspMobileCarousel),
  {
    ssr: false,
  }
);

export type Usps = {
  heading: string;
  paragraph: string;
  video: string;
};

const LandingUsp: React.FunctionComponent = () => {
  // Probably can add lazy load to videos
  const [selectedItem, setSelectedItem] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const width = useWindowWidth();
  const ref = useRef<HTMLDivElement | null>(null);
  const isIntersecting = useOnScreen(ref)[1]?.isIntersecting;

  const usps: Usps[] = [
    {
      heading: t`See Good News every day 🎉`,
      paragraph: t`It’s a special tab that shows you all the latest feel-good
    headlines.`,
      video: "/subdomain/why-use-lumi/landing/NotificationCycle.mp4",
    },
    {
      heading: t`Follow your favourite publishers 📰`,
      paragraph: t`Find over 70 trusted publishers (and counting) in English, BM,
    and Chinese. Follow as many as you like!`,
      video: "/subdomain/why-use-lumi/landing/PublisherCycle.mp4",
    },
    {
      heading: t`Get notifications for topics you like 🔔`,
      paragraph: t`We'll tell you whenever something trends or when there's
    important news to know. Share instantly!`,
      video: "/subdomain/why-use-lumi/landing/TopicCycle.mp4",
    },
    {
      heading: t`See today's COVID-19 stats 😷`,
      paragraph: t`See Malaysia’s vaccination rates and COVID-19 stats that won’t
    confuse you.`,
      video: "/subdomain/why-use-lumi/landing/InformedNewCycle.mp4",
    },
    {
      heading: t`Let AI do the work 👨‍💻`,
      paragraph: t`Get daily headlines read out to you and news summarised by AI
    (the first in Malaysia).`,
      video: "/subdomain/why-use-lumi/landing/AICycle.mp4",
    },
    {
      heading: t`Chat about breaking news 💬`,
      paragraph: t`Talk about the hottest news with verified profiles and fellow
    Malaysians.`,
      video: "/subdomain/why-use-lumi/landing/ChatCycle.mp4",
    },
  ];

  return (
    <>
      <div className="mb-16 px-6 md:mb-40">
        <div>
          <p className="mx-auto max-w-xl pb-6 text-center font-poppins text-[39px] font-bold leading-[1.3] md:text-[51px]">
            <Trans>
              The &nbsp;
              <span className="text-primary">fastest, simplest</span>&nbsp; way
              to read local and international news 🌎
            </Trans>
          </p>
          <p className="mb-20 text-center font-poppins text-text-dark md:mb-40">
            <Trans>It's the only news app you'll need.</Trans>
          </p>
        </div>
        {width > 820 && (
          <div ref={ref}>
            <UspDesktopCarousel
              usps={usps}
              setSelectedItem={setSelectedItem}
              setAutoPlay={setAutoPlay}
              selectedItem={selectedItem}
              autoPlay={autoPlay}
              isIntersecting={isIntersecting}
            />
          </div>
        )}
      </div>

      {width <= 820 && <UspMobileCarousel usps={usps} />}
    </>
  );
};

export default LandingUsp;
